import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { notificationsActions } from "modules/notifications/slices";
import { NOTIFICATION_TYPES } from "modules/notifications/types";
import { isPollStoppedSaga } from "modules/polling/sagas";
import { SagaIterator } from "redux-saga";
import { all, call, put, takeEvery, takeLeading } from "redux-saga/effects";
import { getAxiosErrorMessage } from "utils/getAxiosErrorMessage";
import { axiosInstance } from "../../axios";
import { newsActions } from "./slices";
import { GetNewsFeedPostsParams, GetNewsFeedPostsResponse } from "./types";

const serviceApiPath = "gotham-news/method/";

export function* getNewsFeedPostsSaga(
  action: PayloadAction<GetNewsFeedPostsParams>
): SagaIterator<void> {
  try {
    const { offset, limit, lastId } = action.payload;
    const response: AxiosResponse<GetNewsFeedPostsResponse> = yield call(
      axiosInstance.get,
      `${serviceApiPath}news-feed-posts`,
      {
        params: {
          offset,
          limit,
          lastId
        }
      }
    );
    const isPollStopped: boolean = yield call(isPollStoppedSaga, action);
    if (!isPollStopped) {
      yield put(
        newsActions.getNewsFeedPostsSuccess({
          params: action.payload,
          result: response.data
        })
      );
    }
  } catch (e) {
    yield put(
      newsActions.getNewsFeedPostsFailure({
        params: action.payload,
        error: getAxiosErrorMessage(e)
      })
    );
    yield put(
      notificationsActions.showNotification({
        title: "Failed to get news feed data",
        text: getAxiosErrorMessage(e),
        type: NOTIFICATION_TYPES.ERROR
      })
    );
  }
}

export function* markNewsFeedPostsAsReadSaga(): SagaIterator<void> {
  try {
    yield call(
      axiosInstance.post,
      `${serviceApiPath}news-feed-posts/markAsRead`
    );
    yield put(newsActions.markNewsFeedPostsAsReadSuccess());
  } catch (e) {
    yield put(
      newsActions.markNewsFeedPostsAsReadFailure({
        error: getAxiosErrorMessage(e)
      })
    );
  }
}

export function* watcherSaga(): SagaIterator<void> {
  yield all([
    takeLeading(newsActions.getNewsFeedPostsRequest, getNewsFeedPostsSaga),
    takeEvery(
      newsActions.markNewsFeedPostsAsReadRequest,
      markNewsFeedPostsAsReadSaga
    )
  ]);
}
